import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import FavoriteIcon from "./Global/FavoriteIcon";
import Tags from "./Tags";

const SleeveResult = ({ sleeve, featured = false }) => {
  return (
    <div className="album-details">
      <Row>
        <Col xs={12} sm={6} md={4}>
          <div className="sleeve-cover">
            {sleeve.img_path && (
              <Link to={`/sleeves/view/${sleeve.id}`} title={sleeve.title}>
                <img src={`https://res.cloudinary.com/dreamchimney/image/upload/w_220/sleevery/${sleeve.id}.jpg`} className="sleeve" />
              </Link>
            )}
          </div>
        </Col>

        <Col xs={12} sm={6} md={8}>
          <h2>
            {sleeve.artist} "{sleeve.title}"
          </h2>

          <div className="album-tags">
            <i className="fa fa-tags"></i>
            <Tags tags={sleeve.notes} />
          </div>

          {sleeve.full_name && (
            <div className="album-added">
              Added by {sleeve.full_name} Chimney on {sleeve.created}
            </div>
          )}

          <div className="icons">
            <FavoriteIcon showDescription sleeveId={sleeve.id} className="page-sleeve-favorite" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SleeveResult;
